<table class="app-simulation-result">
  <thead>
    <tr>
      <th></th>
      <th colspan="4" class="data-divider" i18n>Absolute</th>
      <th colspan="4" i18n>Relative</th>
    </tr>
    <tr>
      <th class="data-divider"></th>
      <th colspan="2" class="data-divider" i18n>Individual</th>
      <th colspan="2" class="data-divider" i18n>Collective</th>
      <th colspan="2" class="data-divider" i18n>Individual</th>
      <th colspan="2" i18n>Collective</th>
    </tr>
    <tr class="data-divider">
      <th class="data-divider" i18n></th>
      <th i18n>R</th>
      <th class="data-divider" i18n>NR</th>
      <th i18n>R</th>
      <th class="data-divider" i18n>NR</th>
      <th i18n>R</th>
      <th class="data-divider" i18n>NR</th>
      <th i18n>R</th>
      <th i18n>NR</th>
    </tr>
    <tr>
      <th class="data-divider" i18n>Economic Class</th>
      <th colspan="2" class="data-divider"></th>
      <th colspan="2" class="data-divider"></th>
      <th colspan="2" class="data-divider"></th>
      <th colspan="2"></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of result.classes">
      <td class="data-divider">{{data.economic_class}}</td>
      <td>{{data.individual_res_abs}}</td>
      <td class="data-divider">{{data.individual_nres_abs}}</td>
      <td>{{data.collective_res_abs}}</td>
      <td class="data-divider">{{data.collective_nres_abs}}</td>
      <td>{{data.individual_res_rel}}</td>
      <td class="data-divider">{{data.individual_nres_rel}}</td>
      <td>{{data.collective_res_rel}}</td>
      <td>{{data.collective_nres_rel}}</td>
    </tr>
  </tbody>
  <tfoot>
    <tr>
      <th class="data-divider border-top">Total</th>
      <th class="border-top result-data">{{totals.individual_res_abs}}</th>
      <th class="data-divider border-top result-data">{{totals.individual_nres_abs}}</th>
      <th class="border-top result-data">{{totals.collective_res_abs}}</th>
      <th class="data-divider border-top result-data">{{totals.collective_nres_abs}}</th>
      <th class="border-top result-data">{{totals.individual_res_rel}}</th>
      <th class="data-divider border-top result-data">{{totals.individual_nres_rel}}</th>
      <th class="border-top result-data">{{totals.collective_res_rel}}</th>
      <th class="border-top result-data">{{totals.collective_nres_rel}}</th>
    </tr>
  </tfoot>
</table>

<mat-action-row>
  <button mat-button matDialogClose i18n>CLOSE</button>
</mat-action-row>
